<template>
  <div class="contenedorPrincipal">
    <nav class="nav">
      <router-link :to="{ path: '/' }" class="logo animate__animated animate__wobble">
        <img src="@/assets/images/logo.png" alt="" style="width: 100%;">
      </router-link>
      <!-- Rutas (desktop) -->
      <div class="rutas rutas-desktop">
        <router-link :to="{ path: '/' }">INICIO</router-link>
        <router-link to="/nosotros">NOSOTROS</router-link>
        <router-link to="/servicios">SERVICIOS</router-link>
        <router-link :to="{ path: '/casos-de-exito' }">CASOS DE ÉXITO</router-link>
        <router-link to="/contacto">CONTACTO</router-link>
      </div>
      <!-- Botón hamburguesa (mobile) -->
      <button class="hamburger" :aria-expanded="menuOpen ? 'true' : 'false'" aria-controls="mobile-menu"
        aria-label="Abrir menú" @click="toggleMenu">
        <span :class="{ active: menuOpen }"></span>
        <span :class="{ active: menuOpen }"></span>
        <span :class="{ active: menuOpen }"></span>
      </button>

      <!-- Overlay -->
      <div v-if="menuOpen" class="overlay" @click="closeMenu"></div>

      <!-- Panel móvil -->
      <transition name="slide">
        <div v-if="menuOpen" id="mobile-menu" class="mobileMenu" @click.self="closeMenu">
          <router-link :to="{ path: '/' }" @click="closeMenu">INICIO</router-link>
          <router-link to="/nosotros" @click="closeMenu">NOSOTROS</router-link>
          <router-link to="/servicios" @click="closeMenu">SERVICIOS</router-link>
          <router-link :to="{ path: '/casos-de-exito' }" @click="closeMenu">CASOS DE ÉXITO</router-link>
          <router-link to="/contacto" @click="closeMenu">CONTACTO</router-link>
        </div>
      </transition>
    </nav>
    <router-view />
    <footer>
      <div class="textos">
        <h1>ALMOBY</h1>
        <p>
          CREAMOS SOLUCIONES, IMPULSAMOS TU ÉXITO.
        </p>
      </div>
      <div class="contTituloYrutas">
        <p>ALMOBY</p>
        <div class="rutasFooter">
          <router-link :to="{ path: '/', hash: '#seccionInicial' }">INICIO</router-link>
          <router-link :to="{ path: '/', hash: '#sobreNosotros' }">NOSOTROS</router-link>
          <router-link :to="{ path: '/', hash: '#nuestrosServicios' }">SERVICIOS</router-link>
          <router-link :to="{ path: '/casos-de-exito' }">CASOS DE ÉXITO</router-link>
          <!-- <router-link :to="{ path: '/busqueda-laboral' }">BÚSQUEDA LABORAL</router-link> -->
        </div>
      </div>
      <div class="contTituloYrutas" id="contacto">
        <p>CONTACTO</p>
        <div class="rutasFooter">
          <a href="https://wa.me/5493774516910?text=Hola%20Almoby%2C%20vengo%20desde%20la%20web.%20Quisiera%20hacer%20una%20consulta."
            target="_blank" rel="noopener" aria-label="Escribir por WhatsApp"
            title="Escribir por WhatsApp">3774-516910</a>
          <a href="mailto:info@almoby.com?subject=Consulta%20desde%20la%20web&body=Hola%20Almoby%2C%20quisiera%20más%20información..."
            aria-label="Enviar email" title="Enviar email">info@almoby.com</a>
        </div>
        <p>BÚSQUEDAS</p>
        <div class="rutasFooter">
          <a href="mailto:info@almoby.com?subject=Consulta%20desde%20la%20web&body=Hola%20Almoby%2C%20quisiera%20más%20información..."
            aria-label="Enviar email" title="Enviar CV">info@almoby.com</a>
        </div>
      </div>
    </footer>
    <div class="developedBy">
      <p>© 2025 Developed by</p>
      <svg width="68" height="19" viewBox="0 0 68 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.74261 10.5057H3.78116L2.79378 12.7678H0L5.34692 0H8.16033L4.7138 8.22636H8.79345L6.94883 3.84874L9.05372 2.07909L13.5062 12.7678H10.7114L9.74261 10.5057Z"
          fill="white" />
        <path d="M16.5427 0V12.7678H14.0649L14.0835 0H16.5427Z" fill="white" />
        <path
          d="M17.6602 3.64757H20.1379V12.7679H17.6602V3.64757ZM27.757 3.50195C28.3406 3.50195 28.8343 3.6142 29.2381 3.8397C29.6419 4.06521 29.9673 4.35948 30.2162 4.72453C30.4641 5.08958 30.6448 5.50014 30.7563 5.95621C30.8679 6.41227 30.9237 6.87137 30.9237 7.3335V12.7689H28.4459L28.4645 7.31935C28.4645 7.12418 28.4273 6.94216 28.353 6.77126C28.2786 6.60036 28.1764 6.44767 28.0452 6.31418C27.9151 6.1807 27.7591 6.07351 27.5794 5.99463C27.3997 5.91576 27.2096 5.87632 27.0113 5.87632C26.6013 5.87632 26.2532 6.01992 25.9682 6.30609C25.6821 6.59328 25.5396 6.93103 25.5396 7.32137V12.7709H23.0618V7.32137C23.0618 7.1262 23.0246 6.94418 22.9503 6.77328C22.8759 6.60238 22.7706 6.44969 22.6332 6.31621C22.4958 6.18272 22.3378 6.07857 22.1581 6.00576C21.9784 5.93295 21.776 5.89553 21.5529 5.89553C21.5405 5.89553 21.4847 5.80553 21.3855 5.62452C21.2864 5.44351 21.1738 5.2443 21.0499 5.02689C20.9135 4.77307 20.7452 4.48386 20.5469 4.15824L20.5655 4.12184C21.0995 3.71128 21.6892 3.506 22.3357 3.506C23.0308 3.506 23.5958 3.65667 24.0306 3.95903C24.4654 4.26038 24.8001 4.63453 25.0366 5.08149C25.0861 4.99756 25.1357 4.92475 25.1853 4.86408C25.5323 4.41813 25.9269 4.07937 26.3679 3.85083C26.8089 3.62128 27.2716 3.50701 27.756 3.50701L27.757 3.50195Z"
          fill="white" />
        <path
          d="M36.6808 3.50195C37.3511 3.50195 37.978 3.62633 38.5626 3.87611C39.1462 4.12588 39.6553 4.46262 40.0902 4.88835C40.525 5.31408 40.8689 5.81261 41.124 6.38396C41.3781 6.9553 41.5062 7.56406 41.5062 8.20822C41.5062 8.85237 41.3791 9.46113 41.124 10.0325C40.8689 10.6038 40.525 11.1024 40.0902 11.5281C39.6553 11.9538 39.1462 12.2916 38.5626 12.5403C37.9791 12.7891 37.3521 12.9145 36.6808 12.9145C36.0095 12.9145 35.3826 12.7901 34.799 12.5403C34.2155 12.2916 33.7063 11.9538 33.2715 11.5281C32.8367 11.1024 32.4917 10.6038 32.2376 10.0325C31.9825 9.46113 31.8555 8.85338 31.8555 8.20822C31.8555 7.56305 31.9825 6.95631 32.2376 6.38396C32.4917 5.81261 32.8367 5.31408 33.2715 4.88835C33.7063 4.46262 34.2155 4.12588 34.799 3.87611C35.3826 3.62735 36.0095 3.50195 36.6808 3.50195ZM36.6808 10.7434C36.9907 10.7434 37.2799 10.6766 37.5474 10.5431C37.8138 10.4097 38.0503 10.2236 38.2548 9.98697C38.4593 9.75034 38.6205 9.4763 38.7392 9.16585C38.857 8.8554 38.9158 8.51866 38.9158 8.15361C38.9158 7.81384 38.857 7.48822 38.7392 7.17777C38.6205 6.86733 38.4593 6.60036 38.2548 6.37486C38.0503 6.15036 37.8138 5.97037 37.5474 5.83688C37.2799 5.7034 36.9917 5.63666 36.6808 5.63666C36.3699 5.63666 36.0787 5.7034 35.805 5.83688C35.5313 5.97037 35.2927 6.15036 35.0882 6.37486C34.8837 6.60036 34.7216 6.86733 34.6038 7.17777C34.4861 7.48822 34.4272 7.81283 34.4272 8.15361C34.4272 8.51866 34.4861 8.85642 34.6038 9.16585C34.7216 9.4763 34.8837 9.74933 35.0882 9.98697C35.2927 10.2246 35.5323 10.4097 35.805 10.5431C36.0776 10.6766 36.3699 10.7434 36.6808 10.7434Z"
          fill="white" />
        <path
          d="M47.8206 3.53829C48.4785 3.53829 49.0993 3.65964 49.6838 3.90335C50.2674 4.14705 50.7766 4.48076 51.2114 4.90649C51.6462 5.33222 51.9901 5.83075 52.2452 6.4021C52.4993 6.97344 52.6274 7.5822 52.6274 8.22636C52.6274 8.87051 52.5003 9.47927 52.2452 10.0506C51.9901 10.622 51.6462 11.1205 51.2114 11.5462C50.7766 11.972 50.2674 12.3067 49.6838 12.5494C49.1003 12.7921 48.4796 12.9144 47.8206 12.9144C46.541 12.9144 45.567 12.4523 44.8957 11.528V12.7688H42.4365V0H44.9143V8.22636C44.9143 8.57928 44.9824 8.90691 45.1188 9.21129C45.2551 9.51567 45.4389 9.7796 45.6682 10.0051C45.8975 10.2306 46.1712 10.4096 46.4883 10.5431C46.8054 10.6766 47.1431 10.7433 47.5036 10.7433C47.864 10.7433 48.1831 10.6766 48.5002 10.5431C48.8173 10.4096 49.09 10.2306 49.3203 10.0051C49.5496 9.78062 49.7334 9.51567 49.8697 9.21129C50.0061 8.90691 50.0742 8.57928 50.0742 8.22636C50.0742 7.87344 50.0061 7.5458 49.8697 7.24142C49.7334 6.93704 49.5496 6.67007 49.3203 6.4385C49.09 6.20794 48.8173 6.02794 48.5002 5.90053C48.1831 5.77311 47.8516 5.7094 47.5036 5.7094C47.1555 5.7094 46.8332 5.77615 46.4976 5.90963L46.479 5.92783L46.4604 5.89143L45.5474 4.2502L45.566 4.232C46.1743 3.76987 46.9262 3.5393 47.8196 3.5393L47.8206 3.53829Z"
          fill="white" />
        <path d="M56.1823 11.8091L52.1987 3.64746H54.8624V3.66364L57.2658 9.27496L56.1823 11.8091Z" fill="white" />
        <path
          d="M67.9999 5.55926C67.6838 5.78376 67.3626 5.94555 66.9805 6.07803L66.2947 4.85241L65.5448 3.49433L65.0852 2.66108L64.8467 3.25669C64.5947 3.92309 64.3488 4.57534 64.1113 5.21039L63.4358 7.00836C62.6881 9.05913 62.0074 10.848 61.4156 12.3234C60.8083 13.8352 60.1473 15.0861 59.4502 16.0407C58.7313 17.0569 57.8978 17.8093 56.9745 18.2735C56.0894 18.7184 54.9832 18.952 53.6849 18.9672L53.4681 18.9702V17.9317L53.8141 17.9286C54.8779 17.9013 55.7795 17.7062 56.4901 17.3492C57.2565 16.9639 57.9598 16.3228 58.5826 15.443C59.2333 14.5511 59.854 13.374 60.4282 11.9432C61.0159 10.4779 61.6924 8.69913 62.4381 6.65443L63.1157 4.85241C63.3119 4.33062 63.5123 3.79669 63.7188 3.25063L64.4769 0.86918V0.871202L64.4945 0.758955C64.512 0.676035 64.5244 0.597159 64.5471 0.511204C64.6318 0.539518 64.7072 0.572889 64.7878 0.603226L65.0109 0.704349C65.1586 0.772101 65.2959 0.845921 65.4292 0.921763C65.5438 1.15334 65.676 1.37581 65.7989 1.60333L66.5488 2.96141L67.2986 4.3195L67.9999 5.55724V5.55926ZM54.7229 15.9426C54.7343 15.9426 54.9904 15.9355 55.1175 15.9234C55.4707 15.889 55.8012 15.8152 56.1007 15.7039C56.4054 15.5897 56.6905 15.4299 56.9507 15.2286C57.2079 15.0284 57.4517 14.7665 57.6706 14.453C57.8823 14.1658 58.0941 13.8149 58.3006 13.4115C58.502 13.0161 58.7138 12.5418 58.9286 11.9998C59.1383 11.4719 59.3748 10.848 59.6319 10.1452C59.887 9.44643 60.1731 8.65464 60.4881 7.77285C60.7278 7.11049 60.9839 6.40465 61.2545 5.65533C61.5065 4.95758 61.7771 4.2032 62.0694 3.38411L62.782 1.14626C62.8172 1.06131 62.8502 0.974347 62.8812 0.885359L62.9638 0.643675C62.9876 0.557721 63.0144 0.476822 63.0341 0.386823C62.9401 0.381767 62.8533 0.3848 62.7624 0.383789L62.5022 0.395924C62.3297 0.405025 62.1644 0.423227 62.0002 0.444463C61.7792 0.623451 61.5458 0.786259 61.3196 0.958168L59.9501 1.97547L58.5805 2.99276L57.2699 3.95849C57.5095 4.22747 57.902 4.62185 58.0652 4.77152L59.2705 3.88366L60.64 2.86636L61.3309 2.35367L61.1151 2.91389C60.8063 3.77647 60.5202 4.57534 60.2547 5.3105C59.9841 6.05982 59.729 6.76566 59.4884 7.42903C59.1734 8.30981 58.8883 9.09958 58.6342 9.79632C58.3822 10.487 58.1488 11.1018 57.9412 11.6246C57.7388 12.1363 57.5405 12.5812 57.3535 12.9483C57.1728 13.3023 56.9889 13.6066 56.8051 13.8574C56.6399 14.093 56.4684 14.2811 56.2939 14.4166C56.1193 14.5521 55.9272 14.6593 55.7248 14.7352C55.5151 14.814 55.2765 14.8666 55.0173 14.8909C54.726 14.9182 54.3904 14.9324 54.0206 14.9324H53.4453V15.9426H54.726H54.7229ZM51.0822 14.9131V18.9995H46.731V14.9131H51.0822ZM50.4543 18.2654C50.4543 18.233 50.4285 18.2077 50.3975 18.2077H49.4927C49.4607 18.2077 49.4359 18.234 49.4359 18.2654C49.4359 18.2967 49.4617 18.323 49.4927 18.323H50.3975C50.4295 18.323 50.4543 18.2967 50.4543 18.2654ZM50.4543 17.7941C50.4543 17.7618 50.4285 17.7365 50.3975 17.7365H49.4927C49.4607 17.7365 49.4359 17.7628 49.4359 17.7941C49.4359 17.8255 49.4617 17.8518 49.4927 17.8518H50.3975C50.4295 17.8518 50.4543 17.8255 50.4543 17.7941ZM50.4543 17.3239C50.4543 17.2916 50.4285 17.2663 50.3975 17.2663H49.4927C49.4607 17.2663 49.4359 17.2926 49.4359 17.3239C49.4359 17.3553 49.4617 17.3816 49.4927 17.3816H50.3975C50.4295 17.3816 50.4543 17.3553 50.4543 17.3239Z"
          fill="white" />
      </svg>

    </div>
  </div>
</template>
<script>
export default {
  data() {
    return { menuOpen: false }
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen
      document.documentElement.classList.toggle('no-scroll', this.menuOpen)
    },
    closeMenu() {
      this.menuOpen = false
      document.documentElement.classList.remove('no-scroll')
    }
  },
  mounted() {
    // cerrar con ESC
    window.addEventListener('keydown', this._esc)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this._esc)
    document.documentElement.classList.remove('no-scroll')
  },
  created() {
    // helper para ESC
    this._esc = (e) => { if (e.key === 'Escape') this.closeMenu() }
  }
}
</script>
<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  cursor: url('@/assets/images/logoCursor.png') 16 16, auto;
}

.contenedorPrincipal {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

#app {
  font-family: "MonumentExtended";
  font-weight: 800;
  letter-spacing: 1px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  background:
    radial-gradient(10000px 1500px at 50% 100%,
      rgba(243, 131, 35, .22) 0%,
      rgba(243, 131, 35, .10) 35%,
      rgba(243, 131, 35, 0) 70%),
    #000;
  background-repeat: no-repeat;
  background-color: #000;
  /* fallback */
  min-height: 100vh;
  max-width: 100vw;
}

@font-face {
  font-family: "MonumentExtended";
  src: url("~@/assets/fonts/monumentextended/MonumentExtended-regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: "MonumentExtended";
  src: url("~@/assets/fonts/monumentextended/MonumentExtended-semi-bold.otf") format("truetype");
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: "MonumentExtended";
  src: url("~@/assets/fonts/monumentextended/MonumentExtended-Ultrabold.otf") format("truetype");
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: "WorkSans";
  src: url("~@/assets/fonts/Work_Sans/WorkSans-Regular.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
}

a {
  text-decoration: none;
  color: #ffffff;
}

.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3vw;
  font-size: 1vw;
  height: 140px;
  font-weight: 500;
  width: 100%;
  position: relative;
  z-index: 1;
}

.logo {
  width: 10%;
  display: flex;
  justify-content: center;
}

footer {
  display: flex;
  align-items: start;
  justify-content: space-around;
  padding: 100px;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 32px;
  width: 90%;
  margin-top: 200px;
  margin-bottom: 100px;
}

:root.no-scroll,
:root.no-scroll body {
  overflow: hidden;
}

.rutas {
  width: 80%;
  display: flex;
  justify-content: center;
  gap: 2vw;
}

.rutas a {
  padding: 0.5vw;
  border-radius: 2vw;
  transition: background-color 0.5s ease;
}

.rutas a:hover {
  background-color: #C93400;
  ;

}

.rutas-desktop {
  display: flex;
}

.hamburger {
  display: none;
}

/* Botón hamburguesa */
.hamburger {
  position: relative;
  width: 36px;
  height: 28px;
  border: 1px solid #2a2a2c;
  background: #151516;
  border-radius: 6px;
  display: none;
  align-items: center;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
}

.hamburger span {
  position: absolute;
  width: 18px;
  height: 2px;
  background: #fff;
  transition: transform .25s ease, opacity .2s ease, top .25s ease;
}

.hamburger span:nth-child(1) {
  top: 8px;
}

.hamburger span:nth-child(2) {
  top: 13px;
}

.hamburger span:nth-child(3) {
  top: 18px;
}

.hamburger span.active:nth-child(1) {
  top: 13px;
  transform: rotate(45deg);
}

.hamburger span.active:nth-child(2) {
  opacity: 0;
}

.hamburger span.active:nth-child(3) {
  top: 13px;
  transform: rotate(-45deg);
}

/* Panel móvil (drawer) */
.mobileMenu {
  position: fixed;
  top: 0;
  right: 0;
  width: min(78vw, 360px);
  height: 100vh;
  background: rgba(0, 0, 0, 0.9);
  backdrop-filter: blur(6px);
  border-left: 1px solid #2a2a2c;
  display: flex;
  flex-direction: column;
  padding: 88px 24px 24px;
  gap: 18px;
  z-index: 999999999;
}

.mobileMenu a {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: .6px;
}

/* Overlay oscuro detrás del panel */
.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 1000;
}

/* Transición del drawer */
.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
  opacity: .6;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform .25s ease, opacity .2s ease;
}

.textos {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 800;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.textos h1 {
  font-size: 50px;
  text-align: center;
  text-align: center;
  text-transform: uppercase;
}

.textos p {
  font-size: 8px;
  text-align: left;
  font-weight: 500;
  text-transform: uppercase;
}

.contTituloYrutas {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 20px;
}

.contTituloYrutas p {
  font-weight: 500;
  font-size: 18px;
  line-height: 110%;
}

.rutasFooter {
  display: flex;
  flex-direction: column;
  align-items: start;
  font-weight: 400;
  font-size: 12px;
  gap: 8px;
}

.rutasFooter a:hover {
  text-decoration: underline;
}

.developedBy {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 40px;
}

.developedBy p {
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 160%;
  letter-spacing: -0.2px;
  color: #FFFFFF;

}

.swal2-popup {
  font-family: 'Work Sans', sans-serif !important;
}

.aos-hidden {
  opacity: 0;
  will-change: transform, opacity;
}

.aos-animate {
  opacity: 1;
}

@media screen and (max-width: 1000px) {
  footer {
    flex-direction: column;
    align-items: center;
    gap: 40px;
    margin-top: 100px;
  }

  .contTituloYrutas {
    align-items: center;
    gap: 20px;
  }

  .rutasFooter {
    align-items: center;
    gap: 10px;
  }

  .textos h1 {
    font-size: 30px;
  }

  .textos p {
    font-size: 10px;
    text-align: center;
  }

  .rutas-desktop {
    display: none;
  }

  .hamburger {
    display: inline-flex;
  }

  /* podés ajustar el tamaño del logo mobile */
  .nav {
    padding: 18px 24px;
    height: 72px;
  }
}

@media screen and (max-width: 1000px) {
  .nav {
    height: 80px;
  }
}
</style>
